// extracted by mini-css-extract-plugin
export default {"statusBox":"AdminMoblieUserList_statusBox__0QWuY","modifyBtn":"AdminMoblieUserList_modifyBtn__WWjrX","deleteBtn":"AdminMoblieUserList_deleteBtn__Jm8+z"};